// extracted by mini-css-extract-plugin
module.exports = {"modalHeader":"styles_modalHeader__gQHpG","ctDialog":"styles_ctDialog__29y8l","headModal":"styles_headModal__2n8eH","iconClose":"styles_iconClose__XiUNc"};